import * as Yup from "yup";
import { Form, FormikProvider, FieldArray, useFormik } from "formik";
import { Modal } from "antd";
import {
  Box,
  Grid,
  Button,
  Paper,
  Avatar,
  TextField,
  Typography
} from "@material-ui/core";
// import ItemAutoComplete from './../../../shared/components/ItemAutoComplete';
import ItemsAutoComplete from './../../_customs/ItemsAutoComplete';
// import AUTO_COMPLET_TYPE from './../../../shared/constants/autoCompleteType';
import { useTheme } from '@material-ui/core/styles';
import { useState } from 'react';


export default function ChildsList({
  visible,
  handleCancel,
  onChange,
  ChildItems
}) {

  const theme = useTheme();
  const [Count, setCount] = useState(0);


  const handleCount = (event) => {
    setCount(event.target.value);
  };


  const formSchema = Yup.object().shape({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ChildItems: ChildItems || []
    },
    validationSchema: formSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      onChange(values);
    },
  });

  const { values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;


  const handleChange = (newValues) => {
    const items = newValues.map(item => { return { Id: item.id, ImageUrl: item.imageUrl, BarCode: item.barCode, ItemName: item.name, Count: 0, InternalId: item.internalId } });
    setFieldValue('ChildItems', items);
    //console.log(newValues)
    
  }

  return (
    <Modal
      title=" La liste des Items "
      visible={visible}
      footer={[]}
      confirmLoading={isSubmitting}
      onCancel={handleCancel}
      width={700}
      zIndex={theme.zIndex.drawer + 2}
    >
      <>
        <Box style={{ marginTop: 10 }}>
          {/* <ItemsAutoComplete type={AUTO_COMPLET_TYPE.multiple} size="small" onChange={handleChange} /> */}
           <ItemsAutoComplete
                    multiple
                    size={'small'}
                    onChange={handleChange}
                    minWidth={400}
                /> 
        </Box>
        <Box style={{ marginTop: 20 }}>
          <FormikProvider value={formik} >
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container item spacing={2} justify='flex-end'>

              </Grid>

              <FieldArray
                name="ChildItems"
                render={arrayH => (
                  <>
                    {values.ChildItems && values.ChildItems.map((ChildItem, idx) => {
            
                      return <Paper key={idx} variant="outlined" style={{ width: '100%', padding: 5 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={1}>
                            <Avatar alt="" src={ChildItem.imageUrl} style={{ width: 35, height: 35 }} />
                          </Grid>
                          <Grid item xs={8}>
                            <Typography>
                              {ChildItem.ItemName}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <TextField
                              label="Quantité"
                              variant="outlined"
                              margin="dense"
                              type="number"
                              min={0}
                              max={500}
                              value={Count}
                              onChange={handleCount}
                              {...getFieldProps(`ChildItems.${idx}.Count`)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Paper>
                    })}
                  </>
                )}
              />
              <Grid item container justify="flex-end" style={{ marginTop: 10 }} >
                <Button
                  variant="contained"
                  color='primary'
                  type="submit"
                  size="small"
                  onClick={handleCancel}>
                  Valider
                </Button>
              </Grid>

            </Form>
          </FormikProvider>
        </Box>

      </>

    </Modal>
  );
}
